export default "__VITE_ASSET__2e0b90f5__"